import React from "react";
import "../../account/Account.css"
import Popup from 'reactjs-popup';
import Colors from "../Colors";
import ButtonLoader from "./ButtonLoader";
class DialogModal extends React.Component {

    render() {
        return (
            <Popup 
                contentStyle={{width: "auto", borderRadius:10}}
                open={this.props.active} 
                onClose={this.props.onClose}
                closeOnDocumentClick
                modal
                >
                    {close => (
                    <div style={{display:"flex", maxWidth: 250, flexDirection:"column", padding:40, alignItems:"center" }}>
                        <h3 style={{textAlign:"center"}}>{this.props.text}</h3>
                        <div style={{display:"flex", marginTop:20, justifyContent:"center", flexDirection:"column", alignItems:"center"}}>
                            <ButtonLoader
                                text="Confirm"
                                style={{backgroundColor: Colors.mainColor, width:"100%", }}
                                    // icon={FacebookIcon}
                                onClick={() => {
                                    this.props.onConfirm()
                                    close();
                                }}
                            />
                            <span className="text-hover" onClick={() => {this.props.onClose();close();}} style={{color: Colors.darkText, marginTop:20}}>
                                    Close
                            </span>
                            {/* <ButtonLoader
                                text="Close"
                                style={{backgroundColor: Colors.red, width:120, padding:"12px 20px", margin:"0 20px"}}
                                    // icon={FacebookIcon}
                                onClick={() => {
                                    this.props.onClose();
                                    close();
                                }}
                            /> */}
                        </div>
                    </div>)}
            </Popup>
        );
    }
}

export default DialogModal